// extracted by mini-css-extract-plugin
export default {"CreateProfileModal":"CreateProfileModal_CreateProfileModal__LZoQu","CreateProfileContainer":"CreateProfileModal_CreateProfileContainer__Z5ZJr"};